export const SEGMENTS = [
  { k: "mulheres", label: "Mulheres" },
  { k: "trans", label: "Trans" },
  { k: "homens", label: "Homens" },
  { k: "massagens", label: "Massagens" },
];

export const SEGMENT_LABEL = Object.fromEntries(SEGMENTS.map((s) => [s.k, s.label]));

export const GENDERS = [
  { k: "mulher", label: "Mulheres" },
  { k: "trans", label: "Trans" },
  { k: "homem", label: "Homens" },
];

export const GENDER_LABEL = Object.fromEntries(GENDERS.map((g) => [g.k, g.label]));

export const LEGACY_LABEL = { acompanhante: "Acompanhantes", massagista: "Massagistas" };

export const categoryLabel = (k) => SEGMENT_LABEL[k] || LEGACY_LABEL[k] || k;
